import React from "react";
import { VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import AudienceListItem from "../../AudienceListItem";
import { StepProps, PageLookalikeAudienceFormValues } from "../types";

const LookalikeStep: React.FC<StepProps> = ({ lookalikeOptions }) => {
  const form = useFormContext<PageLookalikeAudienceFormValues>();
  const lookalikeRatio = form.watch("lookalike.ratio");

  return (
    <VStack spacing={6} align="stretch">
      <VStack align="stretch" spacing={8}>
        <VStack align="stretch" spacing={2}>
          <VStack spacing={3} align="stretch">
            {lookalikeOptions.map((option) => (
              <AudienceListItem
                key={option.value}
                title={option.title}
                description={option.description}
                icon={option.icon}
                iconBgColor={option.iconBgColor}
                value={option.value}
                isSelected={lookalikeRatio === option.value}
                onSelect={(value) => {
                  form.setValue("lookalike.ratio", value);
                }}
                isRecommended={option.isRecommended}
                showRadio={true}
                showPlus={false}
              />
            ))}
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  );
};

export default LookalikeStep;
